export enum PriceType {
  DISCOUNT = "DISCOUNT",
  ADDITIONAL = "ADDITIONAL",
}

export interface MenuOption {
  id: string;
  name: string;
  price: number;
  priceType: PriceType;
  sortIndex: number;
}

export interface MenuOptionGroup {
  id: string;
  name: string;
  sortIndex: number;
  /** 必須グループかどうか。BE 未対応レスポンスでは欠落するため、欠落時は true（必須）として扱う */
  required?: boolean;
  menuOptions?: MenuOption[];
}

export interface MenuOptionMenuOptionGroup {
  id: string;
  storeId: string;
  menuOptionGroupId: string;
  menuOptionId: string;
  sortIndex: number;
}

export interface MenuOptionState {
  menuOptions: MenuOption[];
  menuOptionGroups: MenuOptionGroup[];
  menuOptionMenuOptionGroup: MenuOptionMenuOptionGroup[];
  loading: boolean;
  error: string | null;
}